import React from 'react';
import './Slider.scss';

const Slider = ({ children, active = false, className = '' }) => {
    return (
        <div className={`slider-calender ${active ? 'active' : ''} ${className}`}>
            <div className='slider-content'>
                {children}
            </div>
        </div>
    )
}

export default Slider;